<template>
  <div>
    <v-stepper v-model="stp" class="c-main-shadow">
      <v-stepper-header>
        <v-stepper-step :complete="stp > 1" step="1">{{ $T('page.community.create_community.step1') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="stp > 2" step="2">{{ $T('page.community.create_community.step2') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">{{ $T('page.community.create_community.step3') }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1" class="c-content one">
          <v-container v-bind="{ [`grid-list-${leTbS ? 'sm' : 'lg'}`]: true }" text-xs-left>
            <v-layout column wrap>
              <v-flex>
                <v-text-field
                  data-vv-name="name"
                  data-vv-validate-on="blur"
                  ref="input_name"
                  :label="$T('attributes.community_name')"
                  v-model="community.name"
                  color="clr-primary"
                  counter="100"
                  v-validate="'required|max:100'"
                  :error-messages="getMessage('name')"
                  required
                  autofocus
                  :disabled="sending"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <select-cover
                  class="c-select-cover"
                  ref="cCover"
                  type="community"
                  coverPath="/imgs/covers/community/green.jpg"
                  :center="!!leTbS"
                />
              </v-flex>
              <v-flex>
                <v-layout row wrap class="c-genre">
                  <v-flex :xs6="!leTbS" :xs12="!!leTbS">
                    <v-select
                      data-vv-name="genre"
                      :items="$commin.countryGenres()"
                      item-text="value"
                      item-value="key"
                      ref="input_genre"
                      :label="$T('attributes.genre')"
                      v-model="community.genre"
                      color="clr-primary"
                      v-validate="'required'"
                      :error-messages="getMessage('genre')"
                      required
                      :disabled="sending"
                      @change="community.sub_genre = null"
                    ></v-select>
                  </v-flex>
                  <v-flex :xs6="!leTbS" :xs12="!!leTbS" class="c-sub-genre">
                    <v-select
                      data-vv-name="sub_genre"
                      :items="$commin.countryGenres(community.genre).subGenres"
                      item-text="value"
                      item-value="key"
                      ref="input_sub_genre"
                      :label="$T('attributes.sub_genre')"
                      v-model="community.sub_genre"
                      color="clr-primary"
                      v-validate="'required'"
                      :error-messages="getMessage('sub_genre')"
                      required
                      :disabled="sending || !community.genre"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <div class="c-foot-btn">
            <v-btn color="clr-primary" @click="nextStep(1)">{{ $T('button.next') }}</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2" class="c-content">
          <v-container grid-list-lg text-md-left>
            <v-layout column wrap>
              <div class="c-explain c-top">{{ $T('page.community.create_community.step2_explain') }}</div>
              <div class="c-explain c-top2 f-danger">{{ $T('page.community.create_community.step2_explain2') }}</div>

              <v-flex class="c-pub-title">
                {{ $T('attributes.publicity_community') }}
              </v-flex>
              <v-flex class="c-pub-content">
                <v-radio-group
                  class="c-radio-g"
                  v-model="community.publicity_community"
                  data-vv-name="publicity_community"
                  v-validate="'required'"
                  hide-details
                  :disabled="sending"
                  @change="dirtyPublicity = true"
                >
                  <div v-if="leTbS">
                    <div v-for="p in pcs" :key="p.v">
                      <v-radio color="clr-primary" :key="p.v" :label="p.l" :value="p.v" class="c-radio" hide-details />
                    </div>
                    <div class="c-explain selected">{{ publicityCommunityExplain }}</div>
                  </div>
                  <v-layout v-else row wrap>
                    <v-flex v-for="p in pcs" :key="p.v" xs4>
                      <div class="c-btn" :class="{ selected: community.publicity_community == p.v }">
                        <v-radio
                          color="clr-primary"
                          :key="p.v"
                          :label="p.l"
                          :value="p.v"
                          class="c-radio"
                          hide-details
                        />
                        <v-card-text class="c-explain">{{ p.e }}</v-card-text>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>

              <v-flex class="c-pub-title">
                {{ $T('attributes.publicity_member') }}
              </v-flex>
              <v-flex class="c-pub-content">
                <div v-if="leTbS">
                  <v-switch
                    data-vv-name="publicity_member"
                    v-validate="'required'"
                    class="c-switch"
                    color="clr-primary"
                    :label="community.publicity_member ? 'ON' : 'OFF'"
                    v-model="community.publicity_member"
                  ></v-switch>
                  <div class="c-explain selected">{{ publicityMemberExplain }}</div>
                </div>
                <v-radio-group
                  v-else
                  class="c-radio-g"
                  v-model="community.publicity_member"
                  data-vv-name="publicity_member"
                  v-validate="'required'"
                  hide-details
                  :disabled="sending"
                  @change="dirtyPublicity = true"
                >
                  <v-layout row wrap>
                    <v-flex v-for="p in pms" :key="p.v" :xs6="!leTbS" :xs12="!!leTbS">
                      <div class="c-btn" :class="{ selected: community.publicity_member == p.v }">
                        <v-radio
                          color="clr-primary"
                          :key="p.v"
                          :label="p.v ? 'ON' : 'OFF'"
                          :value="p.v"
                          class="c-radio"
                          hide-details
                        />
                        <v-card-text class="c-explain">{{ p.e }}</v-card-text>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>

          <div class="c-foot-btn">
            <v-btn color="clr-primary" @click="nextStep(2)">{{ $T('button.next') }}</v-btn>

            <v-btn flat @click="stp = 1">{{ $T('button.back') }}</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="3" class="c-content">
          <v-container grid-list-lg text-xs-left>
            <v-layout column wrap>
              <div class="c-explain c-top">{{ $T('page.community.create_community.step3_explain') }}</div>
              <v-flex>
                <v-text-field
                  data-vv-name="profile"
                  data-vv-validate-on="blur"
                  ref="input_profile"
                  :label="$T('attributes.profile')"
                  v-model="community.profile"
                  color="clr-primary"
                  counter="50"
                  v-validate="'required|max:50'"
                  :error-messages="getMessage('profile')"
                  required
                  autofocus
                  :disabled="sending"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <select-cover ref="pCover" type="profile" :center="!!leTbS" />
              </v-flex>
            </v-layout>
          </v-container>

          <div class="c-foot-btn">
            <v-btn color="clr-primary" :loading="sending" @click="nextStep(3)">{{ $T('button.register') }}</v-btn>
            <v-btn flat :disabled="sending" @click="stp = 2">{{ $T('button.back') }}</v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <msg-dialog ref="msg_dialog" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UTILS from '../../utils/utils';
import communityListDialog from '../common/CommunityListDialog.vue';

import { getMemberMyPageSetting, getCovers } from '../../api/member';
import { createCommunity } from '../../api/community';

import { CONST } from '../../constant';
import selectCover from '../common/SelectCover.vue';

export default {
  beforeRouteEnter(to, from, next) {
    UTILS.startLoading();
    getMemberMyPageSetting()
      .then(function(response) {
        UTILS.stopLoading();
        next(vm => vm.setSetting(from, response));
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  data: function() {
    return {
      stp: 0,
      from: null,
      community: {
        name: null,
        genre: null,
        sub_genre: null,
        country: this.$store.state.user.country,
        publicity_community: null,
        publicity_member: null,
        profile: null,
      },
      dirtyPublicity: false,
      apiErrors: {},
      sending: false,
      pcs: [
        {
          v: 1,
          l: $T('page.community.setting.publicity_community.private'),
          e: $T('page.community.create_community.publicity_community.private'),
        },
        {
          v: 2,
          l: $T('page.community.setting.publicity_community.semi_public'),
          e: $T('page.community.create_community.publicity_community.semi_public'),
        },
        {
          v: 3,
          l: $T('page.community.setting.publicity_community.public'),
          e: $T('page.community.create_community.publicity_community.public'),
        },
      ],
      pms: [
        { v: true, e: $T('page.community.create_community.publicity_member.true') },
        { v: false, e: $T('page.community.create_community.publicity_member.false') },
      ],
    };
  },
  components: {
    'select-cover': selectCover,
  },
  computed: {
    publicityCommunityExplain() {
      if (this.community.publicity_community == null) return '';
      var v = Number(this.community.publicity_community);
      for (var p of this.pcs) {
        if (p.v == v) {
          return p.e;
        }
      }
      return '';
    },
    publicityMemberExplain() {
      if (this.community.publicity_member == null) return '';
      return this.pms[this.community.publicity_member ? 0 : 1].e;
    },
  },
  methods: {
    ...mapActions({
      refreshCommunity: 'refreshCommunity',
    }),
    setSetting(from, loadedSetting) {
      this.from = from;
      if (loadedSetting.name) {
        this.community.profile = loadedSetting.name;
      }
      if (loadedSetting.cover_path) {
        this.$refs.pCover.setPath(loadedSetting.cover_path);
      }
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    nextStep(current) {
      var self = this;
      if (current == 1) {
        this.validate(['name', 'genre', 'sub_genre'], function(result) {
          if (!result) return;

          if (!self.dirtyPublicity) {
            var defs = self.$commin.countryGenres(self.community.genre).defs[self.community.sub_genre];
            if (defs) {
              self.community.publicity_community = defs[0];
              self.community.publicity_member = defs[1] == 1;
            }
          }

          $('#view_name').text(self.community.name);
          $('#view_genre').text(
            self.$commin.genres(self.community.genre).value +
              '\n - ' +
              self.$commin.subGenres(self.community.sub_genre).value
          );
          $('#view_summary').show();
          $('#view_stp1').show('slow');

          self.stp = current + 1;
        });
      } else if (current == 2) {
        this.validate(['publicity_community', 'publicity_member'], function(result) {
          if (!result) return;

          if (self.community.publicity_community == 1) {
            $('#view_publicity_community').text($T('page.community.setting.publicity_community.private'));
          } else if (self.community.publicity_community == 2) {
            $('#view_publicity_community').text($T('page.community.setting.publicity_community.semi_public'));
          } else {
            $('#view_publicity_community').text($T('page.community.setting.publicity_community.public'));
          }
          if (self.community.publicity_member) {
            $('#view_publicity_member').text('ON');
          } else {
            $('#view_publicity_member').text('OFF');
          }
          $('#view_stp2').show('slow');

          self.stp = current + 1;
        });
      } else if (current == 3) {
        this.sending = true;
        var self = this;
        this.validate(['profile'], function(result) {
          if (!result) {
            self.sending = false;
            return;
          }
          self.createCommunity();
        });
      }
    },
    validate(fields, callback) {
      this.errors.clear();
      var targets = [];
      for (var i = 0, n = fields.length; i < n; i++) {
        targets.push(this.$validator.validate(fields[i]));
      }
      var self = this;
      Promise.all(targets).then(function(values) {
        for (var i = 0, n = fields.length; i < n; i++) {
          if (self.getMessage(fields[i]) != '') {
            console.log(fields[i] + ' is error ' + self.getMessage(fields[i]));
            return callback(false);
          }
        }
        return callback(true);
      });
    },
    createCommunity() {
      var data = new FormData();
      data.append('name', this.community.name);
      data.append(
        'genre',
        JSON.stringify({
          genre: this.community.genre,
          sub_genre: this.community.sub_genre,
        })
      );
      data.append('country', this.community.country);
      data.append('publicity_community', this.community.publicity_community);
      data.append('publicity_member', this.community.publicity_member);
      data.append('community_cover', this.$refs.cCover.path);
      this.$refs.cCover.appendNewCoversToForm(data, 'community_files');
      data.append('profile_name', this.community.profile);
      data.append('profile_cover', this.$refs.pCover.path);
      this.$refs.pCover.appendDeletedCoversToForm(data, 'profile_deleted');
      this.$refs.pCover.appendNewCoversToForm(data, 'profile_files');
      var self = this;
      createCommunity(data)
        .then(function(response) {
          self.shortMsg($T('page.community.create_community.completed'));
          self.refreshCommunity();
          self.$router.push({ name: 'topHome', params: { id: self.selectedCommunity.id } });
        })
        .catch(function(error) {
          self.sending = false;
          console.error('failed to create community', error);
        });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 10px 24px 10px;
}
.c-btn {
  border: 1px solid #666666;
  border-radius: 3px;
  box-shadow: 0px 0px 3px #cccccc;
  height: 100%;
}
.c-btn.selected {
  transition: 0.5s;
  border: 1px solid #1b5e20;
  background-color: #e8f5e9;
}
.c-explain {
  font-size: 13px;
  color: #666666;
  white-space: pre-wrap;
}
.c-explain.c-top {
  padding: 10px 9px 12px 9px;
  margin-top: 10px;
  font-size: 14px;
}
.c-explain.c-top2 {
  padding: 0px 9px 0px 9px;
  margin-top: -4px;
  font-size: 12px;
}
.c-btn.selected .c-explain {
  transition: 0.5s;
  color: #303030;
}
.c-radio-g {
  margin-top: -10px;
}
.c-radio {
  padding: 16px 0px 0px 16px;
  margin: 0px;
}
.c-foot-btn {
  display: flex;
}
.c-pub-title {
  margin-top: 16px;
}

.le-tbs .container {
  padding-bottom: 20px;
}
.le-tbs .c-content.one .container {
  padding-bottom: 5px;
}
.le-tbs .container .flex {
  padding-top: 5px;
}
.le-tbs .c-select-cover {
  margin-top: 10px;
}
.le-tbs .c-genre {
  flex-direction: column;
}
.le-tbs .c-content {
  padding: 10px 20px 20px 20px;
}
.le-tbs .c-sub-genre {
  margin-top: -20px;
}
.le-tbs .c-radio-g {
  margin-top: -6px;
}
.le-tbs .c-radio {
  padding: 0 0 10px 0;
}
.le-tbs .c-switch {
  margin: 0 0 -10px 2px;
  padding: 0;
}
.le-tbs .c-explain.selected {
  padding: 10px;
  margin-top: 5px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  border: 1px solid #aaaaaa;
  background-color: #fcfcfc;
  border-radius: 3px;
}
.le-tbs .c-pub-title {
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
}
</style>
